/* eslint-disable no-unused-vars, max-len */
const { feWp } = window;
const { addAction } = feWp.hooks;

const stopAutoPlay = ( sliderObj ) => sliderObj.autoplay.stop();

const startAutoPlay = ( sliderObj ) => sliderObj.autoplay.start();

const setAnimationDuration = ( sliderObj, duration ) => {
  sliderObj.el.querySelectorAll( '.swiper-pagination-bullet' )?.forEach( line => {
    line.style.animationDuration = `${duration}ms`;
  } );
};

const handleInteraction = ( swiper, el ) => {
  setAnimationDuration( swiper, 0 );
  stopAutoPlay( swiper );
  el.parentNode.classList.add( 'autoplay-stop' );
};

const changeToFirstSlide = ( sliderObj, settings ) => {
  if( settings.loop ) {
    sliderObj.slideToLoop( 0 );
  } else {
    sliderObj.slideTo( 0 );
  }
};

const setupIntersectionObserver = ( el, swiper, settings ) => {
  const observer = new IntersectionObserver( ( entries ) => {
    entries.forEach( entry => {
      if ( entry.isIntersecting ) {
        el.parentNode.classList.add( 'slider-in-view' );
        if ( settings.autoplay && !el.parentNode.classList.contains( 'autoplay-stop' ) ) {
          changeToFirstSlide( swiper, settings );
          startAutoPlay( swiper );
        }
        observer.unobserve( entry.target );
      } else {
        el.parentNode.classList.remove( 'slider-in-view' );
        if ( settings.autoplay && !el.parentNode.classList.contains( 'autoplay-stop' ) ) {
          changeToFirstSlide( swiper, settings );
          stopAutoPlay( swiper );
        }
      }
    } );
  } );
  observer.observe( el );
};

const updateProgressBar = ( swiper ) => {
  const progressBarFill = swiper.el.querySelector( '.swiper-pagination-progressbar-fill' );
  const activeSlide = swiper.realIndex + 1;
  const progress = ( ( activeSlide / ( swiper.originalSlideCount ) ) ) * 100;
  if ( progressBarFill ) {
    progressBarFill.style.width = progress + '%';
  }
};

const handleDotsInteraction = ( swiper, el, dots ) => {
  dots.forEach( dot => {
    dot.addEventListener( 'click', () => {
      handleInteraction( swiper, el );
    } );
  } );
};

const handleArrowsInteraction = ( swiper, el, arrows ) => {
  arrows.forEach( arrow => {
    arrow.addEventListener( 'click', () => {
      handleInteraction( swiper, el );
    } );
  } );
};

addAction(
  'b3rg_slider_init',
  'b3rg/slider',
  ( settings, el, swiper ) => {
    const isInfinite = settings.loop;
    const isProgressbar = settings.pagination?.type;
    const animateDuration = settings.autoplay ? settings.autoplay.delay: 0;
    const spaceBetween = swiper.params.spaceBetween || 0;
   
    const getSpaceFromLeftEdge = ( swiper ) => {
      const swiperContainer = swiper.el;
      const swiperRect = swiperContainer.getBoundingClientRect();
      return swiperRect.left;
    };
    const updateSwiperBehavior = () => {
      const browserWidth = document.documentElement.clientWidth;
      const spaceFromLeftEdge = getSpaceFromLeftEdge( swiper );
      const totalSlidesWidth = swiper.slides.reduce( ( total, slide, index ) => {
        total += slide.offsetWidth;
        total += spaceBetween;
        return total;
      }, 0 );
      
      if ( ( totalSlidesWidth + spaceFromLeftEdge ) < browserWidth ) {
        el.classList.add( 'all-slides-in-view' );
        swiper.draggable = false;
        swiper.allowTouchMove = false;
      } else {
        el.classList.remove( 'all-slides-in-view' );
        swiper.draggable = true;
        swiper.allowTouchMove = true;
      }
    };

    updateSwiperBehavior();

    window.addEventListener( 'resize', updateSwiperBehavior );

    if ( isInfinite ) {
      swiper.params.supports4k = true;
      swiper.params.longSwipesRatio = 0;
      swiper.params.threshold = 0;
      swiper.params.touchRatio = 0.1;
      swiper.params.resistanceRatio = 0;
      swiper.params.autoplay = {
        delay: settings?.autoplay?.delay || 3000,
      };
      if ( isProgressbar ) {
        swiper.params.pagination = {
          el: '.swiper-pagination',
          type: 'custom',
          renderCustom: function ( swiper, current, total ) {
            return '<div class="swiper-pagination-wrpr"><span class="swiper-pagination-progressbar-fill"></span></div><div class="swiper-fraction-custom">' +
              current +
              '/' + ( swiper.originalSlideCount ) + '</div>';
          },
          renderFraction: function () {
            return '';
          }
        };
        el.querySelector( '.swiper-pagination' ).classList.add( 'swiper-pagination-custom' );
        swiper.on( 'slideChange', function () {
          updateProgressBar( this );
        } );
        swiper.on( 'init', function () {
          // Update the progress bar on initialization
          updateProgressBar( this );
        } );
      }
      swiper.update();
    }

    stopAutoPlay( swiper );
    setupIntersectionObserver( el, swiper, settings );

    swiper.on( 'afterInit', ( swiper )=> {
      const arrows = swiper.el.querySelectorAll( '.e-sld__btn' );
      const dots = swiper.el.querySelectorAll( '.swiper-pagination-bullet' );
      setAnimationDuration( swiper, animateDuration );
      handleDotsInteraction( swiper, el, dots );
      handleArrowsInteraction( swiper, el, arrows );
    } );

    swiper.on( 'click', () => handleInteraction( swiper, el ) );

    swiper.on( 'touchEnd', () => handleInteraction( swiper, el ) );

    // Prevent additional swipes during the transition
    swiper.on( 'slideChangeTransitionStart', () => {
      swiper.allowTouchMove = false;
    } );
    // Re-enable touch dragging after the transition
    swiper.on( 'slideChangeTransitionEnd', () => {
      swiper.allowTouchMove = true;
    } );
  },
  10,
  1,
);